var AccountScreen, AccountView, Focusable, ReactComponent, View, mediator,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

AccountScreen = require('components/header/account_screen');

View = require('base/views/view');

ReactComponent = require('base/lib/traits/react_component');

Focusable = require('base/lib/traits/focusable');

mediator = require('mediator');

module.exports = AccountView = (function(_super) {
  __extends(AccountView, _super);

  function AccountView() {
    return AccountView.__super__.constructor.apply(this, arguments);
  }

  AccountView.prototype.autoRender = true;

  AccountView.prototype.initialize = function() {
    AccountView.__super__.initialize.apply(this, arguments);
    return this.enable(ReactComponent);
  };

  AccountView.prototype.afterRender = function() {
    AccountView.__super__.afterRender.apply(this, arguments);
    return this.renderSimpleComponent(AccountScreen, _(this.options).extend({
      onClose: this.dispose
    }));
  };

  AccountView.prototype.dispose = function() {
    this.unmountComponent();
    return AccountView.__super__.dispose.apply(this, arguments);
  };

  return AccountView;

})(View);
